<template>
  <div class="markdown">
    <div class="messages" ref="messages">
      <template v-for="item in messages">
        <div :key="item.id" v-if="item.type === 'ai'" class="message">
          <div class="avatar">{{item.name}}</div>
          <div class="content markdown-body" v-html="item.content"></div>
        </div>
        <div :key="item.id" v-if="item.type === 'user'" class="message-user">
          <div class="content markdown-body" v-html="item.content"></div>
          <div class="avatar">{{item.name}}</div>
        </div>
      </template>
      <div v-if="isLoading" style="text-align: center;">
        <i class="el-icon-loading" style="color: #409EFF;font-size: 20px;"></i>
      </div>
    </div>
    <div class="footer">
      <el-input placeholder="在这里输入消息..." v-model="topic" @keyup.enter.native="send" autofocus clearable />
      <div class="send-btn" @click="send">
        <i class="el-icon-s-promotion send-btn-icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import MarkdownIt from 'markdown-it'
export default {
  data () {
    return {
      messageContainer: null,
      // topic: '请写一段JavaScript代码计算1+1=?',
      topic: '请根据沈从文先生的《边城》写一篇不少于1000字的读书笔记',
      messages: [
        {id: 0, name: 'AI', type: 'ai', content: '你好，我是AI助手，有什么可以帮助你的吗？'}
      ],
      md: new MarkdownIt(),
      isLoading: false // 是否正在加载
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.messageContainer = this.$refs.messages
    })
  },
  methods: {
    send () {
      if (!this.topic) {
        this.$message.error('请先输入消息！')
        return
      }

      this.messages.push({
        id: this.messages.length,
        name: '我',
        type: 'user',
        content: this.topic
      })
      this.scrollToBottom()
      // this.getAIMessagesByAxios()
      this.getAIMessagesByChatGPT()
    },
    async getAIMessagesByChatGPT () {
      this.isLoading = true
      const topic = this.topic
      this.topic = ''
      const response = await fetch('https://qianfan.baidubce.com/v2/chat/completions', {
        method: 'POST',
        responseType: 'stream',
        headers: {
          'Content-type': 'application/json',
          'appid': 'app-rZt4KcO5',
          'Authorization': 'Bearer bce-v3/ALTAK-mvkmZ45PrO12cElv8fO8Y/849be5455e80a11a4a1c15312ebf144d41d06311'
          // 'appid': 'app-YJ8Uju6i',
          // 'Authorization': 'Bearer bce-v3/ALTAK-Jkhp9qes6EaoBkwviWGWK/4ce32b605b5ad911407947282ce3dfb9c95764f7'
        },
        body: JSON.stringify({
          "model": "ernie-4.5-8k-preview",
          "messages": [
            {
              "role": "user",
              "content": topic
            }
          ],
          "web_search": {
            "enable": false,
            "enable_citation": false,
            "enable_trace": false
          }
        })
      })

      this.isLoading = false
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const reader = response.body.getReader()
      const decoder = new TextDecoder('utf-8')
      while (true) {
        const { done, value } = await reader.read()
        if (done) break

        let message = decoder.decode(value, { stream: true })
        // const data = JSON.parse(message)
        // const realMsg = data.choices[0].message.content
        // this.messages.push({
        //   id: this.messages.length,
        //   name: 'AI',
        //   type: 'ai',
        //   content: this.md.render(realMsg)
        // })

        // 处理SSE格式数据
        let eventEndIndex;
          while ((eventEndIndex = message.indexOf("\n\n")) !== -1) {
            const eventData = message.slice(0, eventEndIndex);
            message = message.slice(eventEndIndex + 2);

            const lines = eventData.split("\n");
            for (const line of lines) {
              if (line.startsWith("data:")) {
                const jsonData = JSON.parse(line.slice(5).trim());
                if (jsonData.event === "message") {
                  // 更新对话ID
                  if (jsonData.conversation_id) {
                    this.conversationId = jsonData.conversation_id;
                  }
                  // 累加内容
                  if (jsonData.answer) {
                    aiMessage.content += jsonData.answer;
                  }
                } else if (jsonData.event === "error") {
                  throw new Error(jsonData.error);
                }
              }
            }
          }
      }
    },
    getAIMessagesByAxios () { // chat接口调用
      this.isLoading = true
      const options = {
        'method': 'POST',
        'url': 'https://qianfan.baidubce.com/v2/chat/completions',
        'headers': {
                'Content-Type': 'application/json',
                'appid': 'app-rZt4KcO5',
                'Authorization': 'Bearer bce-v3/ALTAK-mvkmZ45PrO12cElv8fO8Y/849be5455e80a11a4a1c15312ebf144d41d06311'
                // 'appid': 'app-YJ8Uju6i',
                // 'Authorization': 'Bearer bce-v3/ALTAK-Jkhp9qes6EaoBkwviWGWK/4ce32b605b5ad911407947282ce3dfb9c95764f7'
        },
        data: JSON.stringify({
                "model": "ernie-4.5-8k-preview",
                "messages": [
                        {
                                "role": "user",
                                "content": this.topic
                        }
                ],
                stream: false,
                "web_search": {
                        "enable": false,
                        "enable_citation": false,
                        "enable_trace": false
                }
        })
      }
      this.topic = ''

      axios(options).then(response => {
        this.isLoading = false
        // this.putMessages(response.data.choices[0].message.content)
        // const reader = response.data.getReader()
        // console.log(response.data)
        const reader = response.data.getReader()
        this.putStreamMessages(reader)
      })
      .catch(error => {
        this.isLoading = false
        console.log(error)
        throw new Error(error);
      })
    },
    putMessages (message) { // 输出响应消息
      this.messages.push({
        id: this.messages.length,
        name: 'AI',
        type: 'ai',
        content: this.md.render(message)
      })
    },
    scrollToBottom () { // 消息滚动到底部
      this.$nextTick(() => {
        this.messageContainer.scrollTop = this.messageContainer.scrollHeight
      })
    }
  }
}
</script>

<style lang="less" scoped>
.markdown {
  max-width: 600px;
  width: 100%;
  height: 90%;
  margin: 5% auto;
  padding: 20px 16px;
  border: 1px solid #ccc;
  border-radius: 10px;
  display: flex;
  flex-flow: column nowrap;
  .messages {
    flex: 1;
    overflow: auto;
    .message, .message-user {
      display: flex;
      flex-flow: row nowrap;
      margin-bottom: 20px;
      .avatar {
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 50%;
        background-color: #409eff;
        color: #fff;
      }
      .content {
        flex: 1;
        line-height: 40px;
        padding: 0 20px;
        border-radius: 6px;
      }
    }
    .message {
      margin-right: 50px;
      .avatar {
        margin-right: 10px;
      }
      .content {
        border: 1px solid #D2E9F7;
      }
    }
    .message-user {
      margin-left: 50px;
      justify-content: flex-end;
      .avatar {
        margin-left: 10px;
      }
      .content {
        background-color: #D2E9F7;
        text-align: end;
      }
    }
  }
  .footer {
    margin-top: 30px;
    border-radius: 10px;
    display: flex;
    flex-flow: row nowrap;
    .topic-box {
      flex: 1;
    }
    .send-btn {
      margin-left: 12px;
      padding: 0 16px;
      border-radius: 4px;
      height: 40px;
      line-height: 40px;
      background-color: #409eff;
      .send-btn-icon {
        font-size: 18px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
</style>
<style>
	.markdown-body {
		box-sizing: border-box;
		min-width: 200px;
		max-width: 980px;
		margin: 0 auto;
		padding: 45px;
	}

	@media (max-width: 767px) {
		.markdown-body {
			padding: 15px;
		}
	}
</style>